import React from 'react'
import { StyleSheet } from 'react-native'

import { H4, XStack } from '@zet/design-system'

import Cards from '../../../../assets/svgs/cards.svg'

export const TestBrandApplicationHeader = ({ header }: { header: string }) => {
  return (
    <XStack className="items-center justify-between bg-[#051115] pl-3">
      <H4 style={styles.headerText} className="text-white">
        {header}
      </H4>
      <Cards />
    </XStack>
  )
}

const styles = StyleSheet.create({
  headerText: {
    fontSize: 20,
    lineHeight: 24,
    fontWeight: '700',
  },
})
